/**
 * @param {Array} recordTypesChecked - An array of objects representing the record types checked, each with the following properties:
 *     - recordTypeChecked: A boolean value indicating if the record type is checked
 *     - datesChecked: An array of boolean values indicating if each date is checked
 * @returns {number} Returns a decimal fraction indicating what percent of the array values are true
 */
export default {
  getPercentRecordTypesTrue(recordTypesChecked) {
    if (Array.isArray(recordTypesChecked)) {
      const numChecked = recordTypesChecked.filter((val) => val.recordTypeChecked === true).length
      return numChecked / recordTypesChecked.length
    }
    return 0
  },
}
